import { useSelector } from 'react-redux';
import { useFetchActiveOffersQuery } from 'services/api/offer-auction';
import { Vehicle } from '../../../../types/vehicle';
import { AUCTION_TYPES } from 'constants';

export const useListVehiclesOfferAuction = (vehicleId: number) => {
  const bids = useSelector((state: any) => state.bids.itemsData.rows);
  const vehicles = useSelector((state: any) => state.vehicles.vehiclesAdmin.rows || []);
  const { data: offerAuctions } = useFetchActiveOffersQuery(
    {
      vehicleIds:
        vehicles
          .filter((v: Vehicle) => v.auction && v.auction.type === AUCTION_TYPES.AUTOAXESS)
          .map((el: Vehicle) => el.id) ?? []
    },
    {
      skip: vehicles.length === 0
    }
  );

  const offerAuction = offerAuctions?.entities?.[vehicleId] ?? null;
  return offerAuction;
};
